import React, { useRef , useState ,useEffect }  from "react";

import { Document, Page, pdfjs } from 'react-pdf';

import ReactPlayer from "react-player";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
import { Icon, InlineIcon } from '@iconify/react';
//import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';

import {
    Col,
    Container,
    Row,
    Image
} from 'react-bootstrap'

import './catalog.css'

import { listCatalogs } from '../../actions/catalogActions'


import { ReactReader, ReactReaderStyle } from "react-reader";

import  {useDispatch, useSelector} from 'react-redux'



import Message from '../Message/Message' 
import Loader from '../Loader/Loader' ;

import Catalog1 from './epubs/FrameworkSpring.epub';
import Catalog2 from './istqb.pdf';


// This will ensure PDF.js is properly loaded for worker support
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Catalog = ({  history }) => { 

const dispatch = useDispatch(); // Initialize dispatch hook

const catalogList = useSelector(state => state.catalogList)
const { loading, error, catalogs } = catalogList



const [numPagesMap, setNumPagesMap] = useState({});
const onDocumentLoadSuccess = (catalogId, { numPages }) => {
    setNumPagesMap(prev => ({ ...prev, [catalogId]: numPages }));
};

useEffect(() => {
 dispatch(listCatalogs())
 }, [dispatch ])

 
    return (
      
        <Container className="main"  fluid>
        <MDBContainer className="mt-5 mb-4 text-center text-md-left">
    
 
            <section id="blog" className="our-blog ptb-100 main">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <ScrollAnimation animateIn="fadeInUp">
                                <div className="section-title">

                    <h1 style={{color: 'red'}}  >   Catalogues  </h1>
                           <p> Consultez notre catalogue de formation pour découvrir toutes nos offres et trouver celle qui vous convient le mieux</p>
                                </div>

                            </ScrollAnimation>
                        </div>
                    </div>

                    <div className="row">
                       
                    </div>
                </div>
            </section>   
     
                    <MDBRow className="mt-2">
           {loading ? (
            <Loader />
          ) : error ? (
            <Message variant="danger">{error}</Message>
          ) : (
            catalogs.map(catalog => (
              <MDBCol key={catalog._id} md="6" lg="4" className="mb-4">
                <div  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
    height: "700px",     width: "500px",     margin: "auto",
  }}
>



                  <h5 style={{ color: '#ca0c0f', marginBottom: "10px" }}>{catalog.title}</h5>

                <div style={{ height: "650px",  width: "480px" , overflowY: "auto", border: "1px solid #a8a7a7", borderRadius: "4px", padding: "5px" }}>
                    <Document
                      file={`/epubs/${catalog.link}`}
                      onLoadSuccess={(data) => onDocumentLoadSuccess(catalog._id, data)}
                      loading={<Loader />}
                    >
                      {Array.from(
                        new Array(numPagesMap[catalog._id] || 1),
                        (el, index) => (
                          <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            height= {600}
                            width={450}
                          />
                        )
                      )}
                    </Document>
                  </div>

                  <a
                    href={`/epubs/${catalog.link}`}
                    download
                    style={{
                      display: "inline-block",
                      marginTop: "10px",
                      padding: "8px 16px",
                      background: "#ca0c0f",
                      color: "#fff",
                      borderRadius: "4px",
                      textDecoration: "none",
                    }}
                  >
                    Télécharger PDF
                  </a>
                </div>
              </MDBCol>
            ))
          )}
    
                     </MDBRow>

                </MDBContainer>

        
        </Container>
    )
}

export default  Catalog


